<template>
  <div>
    <div class="v-overlay v-overlay--active" style="z-index: 202"></div>
    <v-dialog v-model="open" persistent max-width="640px" :hide-overlay="this.$route.fullPath.includes('details')"
              attach="RealizationModal">
      <v-card>
        <form @submit.prevent="!isProcessing ? onSubmit() : null">
          <v-card-title>
            <span class="headline">Edytowanie daty</span>
          </v-card-title>
          <v-card-text>
            <v-container class="pt-0" grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="voucherDatePicker"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      label="Data wygaśnięcia"
                      v-validate="'required'"
                      slot="activator"
                      v-model="expiredAt"
                      data-vv-name="data wygaśnięcia"
                      :error-messages="errors.collect('data wygaśnięcia')"
                      readonly
                      browser-autocomplete="off">
                    </v-text-field>
                    <v-date-picker v-validate="'required'"
                                   v-model="expiredAt"
                                   data-vv-name="data wygaśnięcia"
                                   :error-messages="errors.collect('data wygaśnięcia')"
                                   @input="voucherDatePicker = false"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" flat @click="goBack">Anuluj</v-btn>
            <v-btn color="blue darken-1" flat :disabled="isProcessing" type="submit">Zapisz</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  /* eslint-disable no-unused-expressions */

  import {mapActions} from 'vuex';

  export default {
    name: 'EditExpiredAt',
    data() {
      return {
        open: true,
        isProcessing: false,
        voucherDatePicker: false,
        expiredAt: null,
      };
    },
    beforeMount() {
      this.fetchVoucherDetails(this.$route.params.voucherId)
        .then((response) => {
          this.expiredAt = this.moment(response.expired_at)
            .format('YYYY-MM-DD');
        });
    },
    watch: {
      voucherDate(newVal) {
        this.expiredAt = this.moment(newVal)
          .format('YYYY-MM-DD');
      },
    },
    methods: {
      ...mapActions('VoucherStore', ['editExpiredAt', 'fetchVoucherDetails']),
      goBack() {
        this.$route.fullPath.includes('details') ? this.$router.push({
          name: 'VoucherDetails',
          params: {voucherId: this.$route.params.voucherId},
        }) : this.$router.push({name: 'Vouchers'});
      },
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              this.editExpiredAt({
                expired_at: this.expiredAt,
                id: this.$route.params.voucherId,
              })
                .then(() => {
                  this.goBack();
                  this.isProcessing = false;
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
